import './Errors.scss'

import React from 'react'
import {useFormContext} from 'react-hook-form'
import {style} from '../../../util/style'

const styles = style('errors')

function isJson(str: string): boolean {
	try {
		JSON.parse(str)
	} catch (e) {
		return false
	}
	return true
}

function capitalize(str: string): string {
	return str.charAt(0).toUpperCase() + str.slice(1)
}

export const Errors: React.FC<{name?: string}> = ({name}) => {
	const {errors} = useFormContext()
	if (!errors) return null

	const filteredErrors = name
		? Object.keys(errors)
				.filter((key) => key === name)
				.reduce((obj, key) => {
					obj[key] = errors[key]
					return obj
				}, {})
		: {...errors}

	if (!Object.keys(filteredErrors).length) return null

	return (
		<div className={styles()}>
			{Object.keys(filteredErrors).map((key: string) => {
				const {message} = filteredErrors[key]
				if (!message) return null

				const messages = isJson(message) ? JSON.parse(message) : [message]
				return messages.map((m) => (
					<p key={m} className={styles('error')}>
						{capitalize(m)}
					</p>
				))
			})}
		</div>
	)
}

export const Error: React.FC = ({children}) => {
	return <p className={styles('error')}>{children}</p>
}
